module.exports = __webpack_public_path__ + "img/james-smith.096d4371.svg";